import React, { useEffect } from 'react';
import { BonusSection } from './components/BonusSection';
import { ClosingArgument } from './components/ClosingArgument';
import { EverythingIncluded } from './components/EverythingIncluded';
import { VisualSection } from './components/VisualSection';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { Guarantee } from './components/Guarantee';
import { Hero } from './components/Hero';
import { PainPoints } from './components/PainPoints';
import { PricingSection } from './components/PricingSection';
import { PurchaseNotification } from './components/PurchaseNotification';
import { ProductGallery } from './components/ProductGallery';
import { SolutionReveal } from './components/SolutionReveal';
import { TestimonialsStrip } from './components/TestimonialsStrip';
import { VolumesSection } from './components/VolumesSection';
import { META_PIXEL_ID } from './utils/tracking';
type MetaPixel = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void;
  queue?: unknown[][];
  push?: (...args: unknown[]) => void;
  loaded?: boolean;
  version?: string;
};
declare global {
  interface Window {
    fbq?: MetaPixel;
    _fbq?: MetaPixel;
  }
}
interface AppProps {
  showTestimonials?: boolean;
  showPurchaseNotifications?: boolean;
}
export function App({
  showTestimonials = true,
  showPurchaseNotifications = true
}: AppProps) {
  useEffect(() => {
    if (typeof window === 'undefined' || typeof document === 'undefined') return;
    try {
      if (!window.fbq) {
        const pixel: MetaPixel = (...args: unknown[]) => {
          if (pixel.callMethod) pixel.callMethod(...args);else pixel.queue?.push(args);
        };
        pixel.queue = [];
        pixel.loaded = true;
        pixel.version = '2.0';
        pixel.push = (...args: unknown[]) => pixel(...args);
        window.fbq = pixel;
        window._fbq = pixel;
        const script = document.createElement('script');
        script.async = true;
        script.src = 'https://connect.facebook.net/en_US/fbevents.js';
        (document.head || document.body || document.documentElement).appendChild(script);
        window.fbq('init', META_PIXEL_ID);
      }
      window.fbq('track', 'PageView');
    } catch (error) {
      console.warn('Meta Pixel initialization failed:', error);
    }
  }, []);
  return <div className="min-h-screen w-full bg-white text-neutral-800" data-id="element-0" data-mp="3gl4pnbwh7qhe">
      <main data-id="element-1" data-mp="3gja35t5k3qb7">
        <Hero data-id="element-2" data-mp="3bmbevr8kqdkx" />
        {showTestimonials && <TestimonialsStrip data-id="element-3" data-mp="3bncpxvplb02n" />}
        <ProductGallery data-id="element-4" data-mp="3bo4n3ayu55v1" />
        <PainPoints data-id="element-5" data-mp="3bkgtycxaylgu" />
        <SolutionReveal data-id="element-6" data-mp="3qbpp11jz4z1d" />
        <VisualSection data-id="element-7" data-mp="3qc93u9ebv7b6" />
        <VolumesSection data-id="element-8" data-mp="3qciodhglsm9h" />
        <BonusSection data-id="element-9" data-mp="3lkhdnzz333lk" />
        <PricingSection data-id="element-10" data-mp="3ljxuyh1m0b6h" />
        <ClosingArgument data-id="element-11" data-mp="3ljpj8sh83bwv" />
        <Guarantee data-id="element-12" data-mp="3liedin47vu34" />
        <FAQ data-id="element-13" data-mp="2xuwsrbjddw9n" />
        <FinalCTA data-id="element-14" data-mp="2xudb7vxmt9w5" />
        <EverythingIncluded data-id="element-15" data-mp="2xtv5m8p2xjbk" />
      </main>
      <Footer data-id="element-16" data-mp="2xsseq0rrbgvn" />
      {showPurchaseNotifications && <PurchaseNotification data-id="element-17" data-mp="2swlk344t9rt0" />}
      <noscript data-id="element-18" data-mp="2svagp5fa2m2f">
        <img height="1" width="1" style={{
        display: 'none'
      }} alt="" src={`https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`} data-id="element-19" data-mp="2stpmxi0sf75m" />
      </noscript>
    </div>;
}